function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.3456 2.78472C16.4411 0.0135102 19.3543 0 19.3543 0C19.3543 0 19.7876 2.60541 17.7059 5.11524C15.4831 7.79519 12.9565 7.35666 12.9565 7.35666C12.9565 7.35666 12.4821 5.24898 14.3456 2.78472ZM13.2231 9.18174C14.3011 9.18174 16.3018 7.69489 18.9061 7.69489C23.3889 7.69489 25.1524 10.8954 25.1524 10.8954C25.1524 10.8954 21.7033 12.6648 21.7033 16.9582C21.7033 21.8015 26 23.4707 26 23.4707C26 23.4707 22.9964 31.953 18.9395 31.953C17.0762 31.953 15.6275 30.6931 13.6642 30.6931C11.6634 30.6931 9.67798 32 8.38483 32C4.68021 32.0001 0 23.9537 0 17.4858C0 11.1223 3.9615 7.78405 7.67722 7.78405C10.0928 7.78405 11.9673 9.18174 13.2231 9.18174Z",
  fill: "#999999"
});

const SvgIos = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 32,
  viewBox: "0 0 26 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios.3ad636f2.svg";
export { ForwardRef as ReactComponent };